import localforage from 'localforage';
import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

import type { RuleItem } from '../utils/types';
import { calculationService } from '../utils/api/calculationService';

export const useRulesStore = defineStore(
  'rules',
  () => {
    const data = ref<RuleItem[] | null>(null);

    const rulesById = computed<Record<number, RuleItem>>(() => {
      const rules: Record<number, RuleItem> = {};

      data.value?.forEach((rule) => {
        rules[rule.id] = rule;
      });
      return rules;
    });

    async function getRulesFromLocalforage() {
      await localforage.getItem<RuleItem[]>('rules');
    }

    async function fetch() {
      await getRulesFromLocalforage();

      if (!data.value) {
        data.value = await calculationService.getRules();
      }
    }

    function invalidate() {
      data.value = null;

      fetch();
    }

    function getRuleById(id: number) {
      return rulesById.value[id] || null;
    }

    return {
      data,
      fetch,
      invalidate,
      getRuleById,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
